export const postType = {
  GET_POST: "get_post",
};
